import { useEffect } from "react";
import { motion } from "framer-motion";

export default function Intro({ onDone }) {
  useEffect(() => {
    const t = setTimeout(onDone, 4200);
    return () => clearTimeout(t);
  }, [onDone]);

  return (
    <motion.div
      data-testid="intro-overlay"
      className="fixed inset-0 z-[60] flex flex-col items-center justify-center bg-[#050505]"
      exit={{ y: "-100%", transition: { duration: 1.1, ease: [0.76, 0, 0.24, 1] } }}
    >
      <div className="overflow-hidden px-4">
        <motion.div
          initial={{ y: "115%" }}
          animate={{ y: "0%" }}
          transition={{ delay: 0.9, duration: 1.3, ease: [0.16, 1, 0.3, 1] }}
          className="gold-text font-serif-accent text-[26vw] leading-none md:text-[12rem]"
          data-testid="intro-monogram"
        >
          S&F
        </motion.div>
      </div>
      <motion.div
        initial={{ scaleX: 0 }}
        animate={{ scaleX: 1 }}
        transition={{ delay: 1.9, duration: 1.1, ease: [0.16, 1, 0.3, 1] }}
        className="mt-6 h-px w-48 bg-gradient-to-r from-transparent via-[#D4AF37] to-transparent md:w-80"
      />
      <motion.p
        initial={{ opacity: 0, y: 12 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 2.4, duration: 0.9 }}
        className="mt-6 text-[11px] tracking-[0.55em] text-[#BDBDB6] md:text-sm"
      >
        WEBDESIGN&nbsp;·&nbsp;AUGSBURG
      </motion.p>
    </motion.div>
  );
}
